import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './organisationMember_row.html?raw';
import _LabelInputBase from '../../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import topic from 'dojo/topic';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import '../../../../moreCore/UI/Edit/Edit';
import selectBox from '../../../../moreCore/UI/SelectBox/SelectBox';
import "../../../../moreCore/UI/SelectBox/SelectBox";
import PhoneInput from '../../../../moreCore/UI/PhoneInput/PhoneInput';
import "../../../../moreCore/UI/PhoneInput/PhoneInput";
import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';
import "../../../../moreCore/UI/CheckBox/CheckBox";
import SelectBox from '../../../../moreCore/UI/SelectBox/SelectBox';
import '../../../../moreCore/UI/SelectBox/SelectBox';
import AR_AddressBlock from '../../AddressBlock/AddressBlock';
import "../../AddressBlock/AddressBlock";

class organisationMember_row extends compose(_LabelInputBase) {
    templateString: any = template;

    /// controls containers ---------------------------START
    CheckBox_Person_interpret: HTMLElement;
    CheckBox_Person_contactPerson: HTMLElement;
    SelectBox_Person_gender: HTMLElement;
    Edit_Person_title: HTMLElement;
    Edit_Person_NobilityPredicate: HTMLElement;
    Edit_Person_name: HTMLElement;
    Edit_Person_namePreposition: HTMLElement;
    Edit_Person_surname: HTMLElement;
    Edit_Person_nameSuffix: HTMLElement;
    Edit_Person_artistName: HTMLElement;
    phoneInput_Person_phone_mobile: HTMLElement;
    phoneInput_Person_phone_landLine: HTMLElement;
    Edit_Person_phone_other: HTMLElement;
    Edit_Person_email: HTMLElement;
    Edit_Person_email_2: HTMLElement;
    deleteButton_container: HTMLElement;
    Edit_Person_function: HTMLElement;
    addressData_tax_container: HTMLElement;
    addressData_residence_container: HTMLElement;
    Edit_reasonForVATExc: HTMLElement;
    SelectBox_notax_type: HTMLElement;
    /// controls containers ---------------------------END

    // ------------------------------------  controls Start
    Person_title: MdsLax<InstanceType<typeof Edit>>;
    Person_nobilityPredicate: MdsLax<InstanceType<typeof Edit>>;
    Person_firstName: MdsLax<InstanceType<typeof Edit>>;
    Person_namePreposition: MdsLax<InstanceType<typeof Edit>>;
    Person_surname: MdsLax<InstanceType<typeof Edit>>;
    Person_nameSuffix: MdsLax<InstanceType<typeof Edit>>;
    Person_artistName: MdsLax<InstanceType<typeof Edit>>;
    Person_email: MdsLax<InstanceType<typeof Edit>>;
    Person_email_2: MdsLax<InstanceType<typeof Edit>>;
    Person_function: MdsLax<InstanceType<typeof Edit>>;
    UID: MdsLax<InstanceType<typeof Edit>>;
    taxNumber: MdsLax<InstanceType<typeof Edit>>;
    reasonForVATExc: MdsLax<InstanceType<typeof Edit>>;
    notax_type: MdsLax<InstanceType<typeof SelectBox>>;
    taxrate: MdsLax<InstanceType<typeof SelectBox>>;

    Person_phone_mobile: PhoneInput;
    Person_phone_landLine: PhoneInput;
    Person_phone_other: PhoneInput;

    Person_gender: MdsLax<InstanceType<typeof selectBox>>;

    Person_interpret: MdsLax<InstanceType<typeof CheckBox>>;
    Person_contactPerson: MdsLax<InstanceType<typeof CheckBox>>;
    isTaxAddress_residenceAddress: MdsLax<InstanceType<typeof CheckBox>>;
    addressData_residence: MdsLax<InstanceType<typeof AR_AddressBlock>>;
    addressData_tax: MdsLax<InstanceType<typeof AR_AddressBlock>>;

    otherTaxId_number: MdsLax<InstanceType<typeof Edit>>;
    otherTaxId_type: MdsLax<InstanceType<typeof Edit>>;


    // ------------------------------------  controls End

    allFields: Array<string> = ["Person_interpret", "Person_contactPerson", "Person_gender", "Person_title", "Person_nobilityPredicate", "Person_firstName", "Person_namePreposition", "Person_surname", "Person_nameSuffix", "Person_artistName", "Person_phone_mobile", "Person_phone_landLine",
        "Person_phone_other", "Person_email", "Person_email_2"];

    _value: any = {};

    isValid: boolean = true;

    // Events Start

    _onChange_Person_interpret(): void {

        this._value["Person_interpret"] = this.Person_interpret.checked;

        if (this.Person_interpret.checked) {
            this.Person_contactPerson.setMandatory(false);
            this.Person_contactPerson.validateInput();
        } else {
            this.Person_contactPerson.setMandatory(true);
        }

        this._onChange();
    }

    _onChange_Person_contactPerson(): void {

        this._value["Person_contactPerson"] = this.Person_contactPerson.checked;

        if (this.Person_contactPerson.checked) {
            this.Person_interpret.setMandatory(false);
            this.Person_interpret.validateInput();
        } else {
            this.Person_interpret.setMandatory(true);
        }

        this._onChange();
    }

    _onChange_Person_function(): void {
        this.add_value(this.Person_function);
        this._onChange();
    }

    _onChange_Person_gender(): void {
        this.add_value(this.Person_gender);
        this._onChange();
    }

    _onChange_Person_personTitle(): void {
        this.add_value(this.Person_title);
        this._onChange();
    }

    _onChange_Person_nobilityPredicate(): void {
        this.add_value(this.Person_nobilityPredicate);
        this._onChange();
    }

    _onChange_Person_firstName(): void {
        this.add_value(this.Person_firstName);
        this._onChange();
    }

    _onChange_Person_namePreposition(): void {
        this.add_value(this.Person_namePreposition);
        this._onChange();
    }

    _onChange_Person_surname(): void {
        this.add_value(this.Person_surname);
        this._onChange();
    }

    _onChange_Person_nameSuffix(): void {
        this.add_value(this.Person_nameSuffix);
        this._onChange();
    }

    _onChange_Person_artistName(): void {
        this.add_value(this.Person_artistName);
        this._onChange();
    }

    _onChange_Person_phone_mobile(): void {
        this.add_value(this.Person_phone_mobile);
        this._onChange();
    }

    _onChange_phone_Person_landLine(): void {
        this.add_value(this.Person_phone_landLine);
        this._onChange();
    }

    _onChange_Person_phone_other(): void {
        this.add_value(this.Person_phone_other);
        this._onChange();
    }

    _onChange_Person_email(): void {
        this.add_value(this.Person_email);
        this._onChange();
    }

    _onChange_Person_email_2(): void {
        this.add_value(this.Person_email_2);
        this._onChange();
    }

    _onChange_taxrate(): void {
        let selectedTaxRate = this.taxrate.getValue();

        if (selectedTaxRate == 'Sonst' ){
            //this.UiModder.domClass.remove(this.SelectBox_notax_type, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_reasonForVATExc, "w3-hide");
        }else{
            //this.UiModder.domClass.add(this.SelectBox_notax_type, "w3-hide");
            this.UiModder.domClass.add(this.Edit_reasonForVATExc, "w3-hide");
        }

        this.add_value(this.taxrate);
        this.add_value(this.notax_type);
    }

    _onChange_notax_type(): void {

        let selectedTaxRateType = this.notax_type.getValue();
        //console.log("selectedTaxRateType", selectedTaxRateType);
        this.add_value(this.notax_type);

        if (selectedTaxRateType == "other") {
            this.UiModder.domClass.remove(this.Edit_reasonForVATExc, "w3-hide");
            this.add_value(this.reasonForVATExc);
        } else {
            this.UiModder.domClass.add(this.Edit_reasonForVATExc, "w3-hide");
            delete this._value["reasonForVATExc"];
        }

        this.add_value(this.notax_type);
    }

    _onChange_reasonForVATExc() {
       this.add_value(this.reasonForVATExc);
    }

    _onChange_taxNumber(): void {
        this.add_value(this.taxNumber);
    }

    _onChange_UID(): void {
        this.add_value(this.UID);
    }


    _onChange_otherTaxId_number(): void {
        this.add_value(this.otherTaxId_number);
    }

    _onChange_otherTaxId_type(): void {
        this.add_value(this.otherTaxId_type);
    }
    // Events End

    add_value(input: any): void {
        let value = input.getValue();
        if (typeof value == "string") value = value.trim();

        if (value != null && value != "" && input.isValid) {
            this._value[this.getAttachPointNameForWidget(input)] = value;

        } else {
            delete this._value[this.getAttachPointNameForWidget(input)];
        }
    }

    _onChange_isTaxAddress_residenceAddress(): void {

        if (this.isTaxAddress_residenceAddress.checked != true) {
            this.UiModder.domClass.remove(this.addressData_residence_container, "w3-hide");
            this.add_value(this.addressData_residence);
        } else {
            this.UiModder.domClass.add(this.addressData_residence_container, "w3-hide");
            delete this._value["addressData_residence"];
        }

        this.add_value(this.isTaxAddress_residenceAddress);
    }

    _onChange_addressData_tax(): void {
        this.add_value(this.addressData_tax);
    }

    _onChange_addressData_residence(): void {
        this.add_value(this.addressData_residence);
    }

    getAttachPointNameForWidget(widget): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    getValue(): any {
        if (this.dataCompletnessCheck) {
            return this._value;
        }
        else {
            return null
        }
    }

    _onChange(): void {

        this.emit("rowValueChange", this);

    }

    validateInput(): boolean {

        let result: boolean = true;
        let mandatoryKeys: string[] = [];

        for (let property of this.allFields) {
            if (this[property] && this[property].isMandatory) {
                mandatoryKeys.push(property);
            }
        }

        if (mandatoryKeys.length) {
            for (let i = 0; i < mandatoryKeys.length; i++) {

                let valueProperty: string = mandatoryKeys[i];

                if (!this._value.hasOwnProperty(valueProperty) || this._value[valueProperty] == null || this._value[valueProperty] == "") {
                    result = false;
                }

                if (this[valueProperty].validateInput()) {
                } else {
                    result = false;
                }
            }
        } else {
            result = true;
        }


        this.isValid = result;

        return result;
    }

    _hideDeleteButton(bool: boolean): void {

        if (bool == true) {
            this.UiModder.domClass.add(this.deleteButton_container, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.deleteButton_container, "w3-hide");
        }
    }

    dataCompletnessCheck(): boolean {

        let result: boolean = true;
        let mandatoryKeys: string[] = [];

        for (let property of this.allFields) {
            if (this[property] && this[property].isMandatory) {
                mandatoryKeys.push(property);
            }
        }

        if (mandatoryKeys.length) {
            for (let i = 0; i < mandatoryKeys.length; i++) {

                let valueProperty: string = mandatoryKeys[i];

                if (!this._value.hasOwnProperty(valueProperty) || this._value[valueProperty] == null || this._value[valueProperty] == "") {
                    result = false;
                }
            }
        } else {
            result = true;
        }

        return result;
    }

    _onClick_deleteRow(): void {
        topic.publish("oranisationMember_row/deleteRow", this);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.Person_gender.setValue("", true, true, null, true); // selectBox.setValue(newValue: string, bSuppressChange?: boolean, forceIfDisabled?: boolean, bSupressValidation?:boolean, delimiter?: string)
        this.Person_phone_landLine.setPlaceholderNumberType("FIXED_LINE");

        this.add_value(this.taxrate);

        let langCode = window.currentLanguageCode2;
        if(langCode == "en" ){
            langCode = "gb";
        }

        if( langCode != "de" ) {
            this.Person_phone_mobile.setCountry(langCode);
            this.Person_phone_landLine.setCountry(langCode);
            this.Person_phone_other.setCountry(langCode);
        }else{

            this.Person_phone_mobile.setCountry("gb");
            this.Person_phone_landLine.setCountry("gb");
            this.Person_phone_other.setCountry("gb");

            // russischer workaround weil durch separateDialCode das deutsche input 100% breite bekommt?!?!? keine ahnung warum nur bei .de
            setTimeout(lang.hitch(this, function(){
                this.Person_phone_mobile.setCountry("de");
                this.Person_phone_landLine.setCountry("de");
                this.Person_phone_other.setCountry("de");
            }), 1000);
        }
    }
}

export default mdsWidget(organisationMember_row);
